// src/utils/migratePasswords.js - FIXED EXPORT
import { collection, doc, getDoc, getDocs, updateDoc } from 'firebase/firestore';
import { db } from '../services/firebaseConfig';
import PasswordService from '../services/PasswordService';

/**
 * Migrate all plain text passwords to hashed passwords
 * This should be run ONCE after implementing password hashing
 */
export const migratePasswords = async () => {
  try {
     
    let migratedCount = 0;
    let skippedCount = 0;

    // 1. Migrate Superadmin Password
     
    const superadminRef = doc(db, 'superadmin', 'admin');
    const superadminDoc = await getDoc(superadminRef);
    
    if (superadminDoc.exists()) {
      const superadminData = superadminDoc.data();
      
      if (!PasswordService.isHashed(superadminData.password)) {
         
        const hashedPassword = await PasswordService.hashPassword(superadminData.password);
        await updateDoc(superadminRef, { 
          password: hashedPassword,
          passwordMigrated: true,
          migratedAt: new Date().toISOString()
        });
        migratedCount++;
         
      } else {
         
        skippedCount++;
      }
    }

    // 2. Migrate Restaurant Passwords
     
    const restaurantsSnapshot = await getDocs(collection(db, 'restaurants'));
    
    for (const restaurantDoc of restaurantsSnapshot.docs) {
      const restaurantData = restaurantDoc.data();
      
      if (restaurantData.password && !PasswordService.isHashed(restaurantData.password)) {
         
        const hashedPassword = await PasswordService.hashPassword(restaurantData.password);
        
        await updateDoc(doc(db, 'restaurants', restaurantDoc.id), { 
          password: hashedPassword,
          passwordMigrated: true,
          migratedAt: new Date().toISOString()
        });
        
        migratedCount++;
         
      } else {
         
        skippedCount++;
      }
    }

     
     
     
    
    return { success: true, migrated: migratedCount, skipped: skippedCount };
  } catch (error) {
    console.error('❌ Password migration failed:', error);
    return { success: false, error: error.message };
  }
};

export default migratePasswords;